import React from "react";
import { Box } from "@sproutsocial/seeds-react-box";
import { Icon } from "@sproutsocial/seeds-react-icon";
import { type TypeCollapsibleContentHeaderProps } from "./ContentHeaderTypes";
import { HeaderContainer, TriggerButton } from "./ContentHeaderHybrid";
import { TitleArea } from "./TitleArea";

export const CollapsibleContentHeader = ({
  title,
  subtitle,
  headingLevel = "h4",
  subtitleAs,
  leftSlot,
  rightSlot,
  rightTitleElement,
  headerActions,
  trigger: TriggerWrapper,
  triggerPosition = "right",
  triggerIcon,
  bordered = true,
}: TypeCollapsibleContentHeaderProps) => {
  const defaultIcon = (
    <Icon
      name="chevron-down-outline"
      className="triggerIcon"
      aria-hidden="true"
    />
  );

  const resolvedIcon = triggerIcon !== undefined ? triggerIcon : defaultIcon;

  return (
    <HeaderContainer bordered={bordered}>
      <TriggerWrapper>
        <TriggerButton type="button">
          {triggerPosition === "left" && <Box mr={400}>{resolvedIcon}</Box>}
          <TitleArea
            title={title}
            subtitle={subtitle}
            headingLevel={headingLevel}
            subtitleAs={subtitleAs}
            leftSlot={leftSlot}
            rightSlot={rightSlot}
            rightTitleElement={rightTitleElement}
          />
          {triggerPosition === "right" && resolvedIcon}
        </TriggerButton>
      </TriggerWrapper>
      {headerActions && <Box ml={300}>{headerActions}</Box>}
    </HeaderContainer>
  );
};

export default CollapsibleContentHeader;
